module.exports = __webpack_public_path__ + "media/highclass/service-process-tb-7e39fa19.svg";